import { WaiverRequests } from '@prisma/client';

// This number needs to correspond with what's in the API for waivers page size
export const WAIVERS_PAGE_SIZE = 20;

export const SORTABLE_KEYS = ['customer', 'waiverName', 'status'] as Array<
  // handle non-keyof types in backend
  keyof WaiverRequests | 'customer' | 'waiverName'
>;

export const OPTIONS_STYLES = {
  leftItemWidth: 22,
  rightItemWidth: 22,
  gap: 8,
} as const;
